export default __webpack_public_path__ + "static/media/logo_large.85ab4fd7.png";